import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { Phone, Mail, MapPin, Navigation } from "lucide-react";
import { business } from "../data/business";
import { AddressLine } from "./AddressLine";

export function Contact() {
  const root = useRef<HTMLElement>(null);

  useGSAP(
    () => {
      const reduce =
        typeof window !== "undefined" &&
        window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
      if (reduce) return;

      gsap.from(".contact-card", {
        y: 28,
        opacity: 0,
        duration: 0.7,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 80%" },
      });
    },
    { scope: root },
  );

  return (
    <section ref={root} id="contact" className="contact-wrap" aria-label="Contact info">
      <div className="contact-card">
        <span className="contact-icon" aria-hidden="true"><Phone /></span>
        <span className="label">CALL TO BOOK</span>
        <a className="value" href={`tel:${business.phoneRaw}`}>{business.phone}</a>
        <span className="meta">Reservations and trip questions. Open hours below.</span>
      </div>

      <div className="contact-card">
        <span className="contact-icon" aria-hidden="true"><Mail /></span>
        <span className="label">EMAIL</span>
        <a className="value" href={`mailto:${business.email}`} style={{ fontSize: 18 }}>
          {business.email}
        </a>
        {/* No SLA promise — we don't have a confirmed reply turnaround
            from the business. Showing one would be a contractual claim
            we can't back. */}
        <span className="meta">For reservations, trip questions, and group inquiries.</span>
      </div>

      <div className="contact-card">
        <span className="contact-icon" aria-hidden="true"><MapPin /></span>
        <span className="label">VISIT US</span>
        <span className="value" style={{ fontSize: 19 }}>
          <AddressLine variant="stacked" />
        </span>
        <span className="meta">Look for the green Ocoee Whitewater Lodge sign on the right side of US-64, just beyond Parksville Lake.</span>
        <span className="meta">~1 hr from Chattanooga · ~2.5 hrs from Atlanta</span>
        <a
          className="contact-directions"
          href={`https://maps.google.com/?q=${encodeURIComponent(business.address.full)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Navigation aria-hidden="true" /> Get Directions
        </a>
      </div>
    </section>
  );
}
